import { render, staticRenderFns } from "./opus.vue?vue&type=template&id=2e9750e3&scoped=true&"
import script from "./opus.vue?vue&type=script&lang=js&"
export * from "./opus.vue?vue&type=script&lang=js&"
import style0 from "./opus.vue?vue&type=style&index=0&id=2e9750e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9750e3",
  null
  
)

export default component.exports